import { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import './TrustedBySection.css';

const LOGOS = [
  { src: '/img/nacion.png', alt: 'La Nación' },
  { src: '/img/telefe.png', alt: 'Telefe' },
  { src: '/img/clarin.png', alt: 'Clarín' },
];

function TrustedBySection() {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.4, rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="trusted-by"
      ref={sectionRef}
      className={`trusted-by ${isVisible ? 'trusted-by--visible' : ''}`}
      aria-label="Expertise and recognition"
    >
      <div className="trusted-by__inner">
        <p className="trusted-by__headline">{t('trustedBy.headline')}</p>
        <div className="trusted-by__logos" role="list">
          {LOGOS.map(({ src, alt }) => (
            <div key={src} className="trusted-by__logo" role="listitem">
              <img src={src} alt={alt} className="trusted-by__logo-img" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustedBySection;
